import {
    NationBuilderAppType,
    NationBuilderMobileAppType,
    NationBuilderNeeds,
    NationBuilderOrganizationType,
    NationBuilderPoliticalGroup,
} from '__generated__/types';

export const nationBuilderNeeds = [
    {
        value: NationBuilderNeeds.NEW_SITE,
        title: __('Create a new NationBuilder website'),
    },
    {
        value: NationBuilderNeeds.MIGRATE_SITE,
        title: __('Migrate an existing website to NationBuilder'),
    },
    {
        value: NationBuilderNeeds.SITE_CHANGES,
        title: __('Make changes to a NationBuilder website'),
    },
    {
        value: NationBuilderNeeds.APP_OR_INTEGRATION,
        title: __('Develop a NationBuilder app or integration'),
    },
];

export const nationBuilderAppType = [
    {
        value: NationBuilderAppType.WEB,
        title: __('Web'),
    },
    {
        value: NationBuilderAppType.MOBILE,
        title: __('Mobile'),
    },
];

export const nationBuilderMobileAppType = [
    {
        value: NationBuilderMobileAppType.IOS,
        title: __('iOS'),
    },
    {
        value: NationBuilderMobileAppType.ANDROID,
        title: __('Android'),
    },
    {
        value: NationBuilderMobileAppType.BOTH,
        title: __('Both'),
    },
];

export const nationBuilderOrganizationType = [
    {
        value: NationBuilderOrganizationType.POLITICAL,
        title: __('Political'),
    },
    {
        value: NationBuilderOrganizationType.NONPROFIT,
        title: __('Nonprofit'),
    },
    {
        value: NationBuilderOrganizationType.ADVOCACY,
        title: __('Advocacy'),
    },
    {
        value: NationBuilderOrganizationType.BUSINESS,
        title: __('Business'),
    },
];

export const nationBuilderPoliticalGroup = [
    {
        value: NationBuilderPoliticalGroup.NONPARTISAN,
        title: __('Nonpartisan'),
    },
    {
        value: NationBuilderPoliticalGroup.CONSERVATIVE,
        title: __('Conservative'),
    },
    {
        value: NationBuilderPoliticalGroup.PROGRESSIVE,
        title: __('Progressive'),
    },
];
